import React from 'react';

export default function FormCard({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative w-full group">
      {/* Gradient border wrapper */}
      <div
        className="absolute -inset-[1.5px] rounded-2xl opacity-80"
        style={{
          background: 'linear-gradient(135deg, hsl(42, 100%, 65%) 0%, hsl(25, 95%, 60%) 30%, hsl(330, 80%, 62%) 70%, hsl(310, 70%, 68%) 100%)',
        }}
      />

      {/* Inner card */}
      <div className="relative rounded-2xl bg-[hsl(var(--card))]/95 backdrop-blur-[2px] px-6 py-7 sm:px-8 sm:py-9">
        {children}
      </div>
    </div>
  );
}
